
import { useQueryClient } from "@tanstack/react-query";
import { CourseForm } from "./courses/details";

type CourseDetailsProps = {
  course: {
    id: string;
    course_name: string;
    course_type: string;
    description: string;
    duration_hours: number;
    price: number;
    original_price: number | null;
    state_fee: number | null;
    language: string;
    benefits?: any;
    footer_text?: any;
    state?: string;
    created_at?: string;
    updated_at?: string;
  };
};

export function CourseDetails({ course }: CourseDetailsProps) {
  const queryClient = useQueryClient();
  
  const handleDeleted = () => {
    queryClient.invalidateQueries({ queryKey: ['courses'] });
  };

  return (
    <CourseForm 
      course={course} 
      onDeleted={handleDeleted} 
    />
  );
}
